import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Divider,
    Icon,
    Stack,
    Typography,
} from "@mui/material";
import { MapIcons } from "../../../constants/MapConstants";

export default function MapTutorial() {
    return (
        <Box>
            <Accordion>
                <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                    <Typography>آموزش نقشه</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack
                        direction="column"
                        gap={1}
                        divider={<Divider />}
                    >
                        {MapIcons.map((i) => {
                            return (
                                <Stack
                                    direction="row"
                                    gap={1}
                                >
                                    <img
                                        width={20}
                                        height={25}
                                        alt="pin"
                                        src={i.src}
                                    ></img>
                                    <Typography>{i.title}</Typography>
                                </Stack>
                            );
                        })}
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
